import $ from "jquery";
import DiffMatchPatch from "diff-match-patch";

import "./pick_reviewer_on_pending_commit";

const minimise = function() {
  $("#application-form-object-box").addClass("minimised");
};

const maximise = function() {
  $("#application-form-object-box").removeClass("minimised");
};

const submitNotificationForm = function (e) {
  const $notificationFieldsContainer = $(this).closest("form").find(".notification-fields");
  const $notificationFields = $notificationFieldsContainer.find("[name^='notification[']");

  const notificationSubmitText = $notificationFields.serialize();
  const url = $notificationFieldsContainer.data("url");

  $.post(url, notificationSubmitText)
  .fail(function (xhr, status, error) {
    window.airbrake.notify(error);
    alert("Error! Notification record could not be created. Please let a programmer know.");
  })
  .always(function () {
  });

  e.stopPropagation();
  e.preventDefault();
};

const diffFromCurrent = function () {
  const $diffableContainers = $(".diff-text-or-string .diff-inner-wrapper");

  $diffableContainers.each(function () {
    const $diffableContainer = $(this);

    const $currentInput = $diffableContainer.children().first().find(".form-control");
    const $oldContainer = $diffableContainer.find(".old-value .value");
    const $liveVsOldContainer = $diffableContainer.find(".live-value .diff-old.value");
    const $liveVsCurrentContainer = $diffableContainer.find(".live-value .diff-current.value");

    const currentText = $currentInput.val();
    const oldText = $oldContainer.text();
    const liveText = $liveVsOldContainer.text();


    const dmp = new DiffMatchPatch();
    const oldVsCurrentDiff = dmp.diff_main(oldText, currentText);
    const liveVsOldDiff = dmp.diff_main(oldText, liveText);
    const liveVsCurrentDiff = dmp.diff_main(liveText, currentText);

    if ($oldContainer.length > 0) {
      dmp.diff_cleanupSemantic(oldVsCurrentDiff);

      $oldContainer.text("");
      $oldContainer.html(dmp.diff_prettyHtml(oldVsCurrentDiff));
    }

    if ($liveVsCurrentContainer.length > 0) {
      dmp.diff_cleanupSemantic(liveVsCurrentDiff);

      $liveVsCurrentContainer.text("");
      $liveVsCurrentContainer.html(dmp.diff_prettyHtml(liveVsCurrentDiff));
    }

    if ($oldContainer.length > 0 && $liveVsOldContainer.length > 0) {
      dmp.diff_cleanupSemantic(liveVsOldDiff);

      $liveVsOldContainer.text("");
      $liveVsOldContainer.html(dmp.diff_prettyHtml(liveVsOldDiff));
    }
  });
};

const addUserToCollectionBox = () => {
  const $container = $(".add-user-to-collection-box");

  const $select = $container.find(".edit-user-select");
  const $btn = $container.find(".edit-user-button");
  const anchor = $btn.data("collection");

  $btn.click((e) => {
    const disabled = $btn.is(":disabled");

    if (disabled) {
      e.preventDefault;
      e.stopPropagation();
    }
  });

  $select.change(() => {
    const value = $select.val();

    if (!value) {
      $btn.prop("disabled", true);
      $btn.attr("disabled", true);
      $btn.prop("href", "#");
    } else {
      $btn.prop("disabled", false);
      $btn.attr("disabled", false);

      $btn.prop("href", `/accounts/${value}/edit#${anchor}`);
    }
  });
};

const disableAjaxButton = () => {
  $("body").on("click", ".datatable-ajax-button", (e) => {
    const $btn = $(e.target);

    if ($btn.hasClass("disabled")) {
      e.preventDefault();
      e.stopPropagation();
    }

    $btn.addClass("disabled");
    $btn.addClass("wait");
  });
};

const highlightWdVersionCollectionRow = () => {
  const anchor = window.location.hash;

  if (!anchor) { return; }

  $(".wd-version-collection-row .anchor" + anchor).closest("tr").addClass("highlight");
};

const init = function() {
  $("#application-form-object-box .minimise-button").click(minimise);
  $("#application-form-object-box .maximise-button").click(maximise);
  $(".create-notification-button").click(submitNotificationForm);

  diffFromCurrent();
  addUserToCollectionBox();
  disableAjaxButton();
  highlightWdVersionCollectionRow();
};

$(document).on("turbolinks:load", function() {
  init();
});
